export enum AccessEnum {
  ARM_FM_ACCESS = 'control-oper',
  SVETOFOR_ACCESS = 'svetofor',
  REJECTION_ACCESS = 'reestr_rejection',
  REQUESTS_GA_ACCESS = 'requests-government-agencies',
  ACCESS_4937 = 'arm_4937_u',
  OES_ACCESS = 'oes-otkaz-goz',
  STRATEG_ACCESS = 'arm_strateg',
  ARM_407_ACCESS = 'arm_407'
}

export function getFMAccessList(): Array<string> {
  return Object.values(AccessEnum);
}
